import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { RouterLink } from '@angular/router';

import { Maybe } from '../../../types/base';
import { ButtonComponent } from '../../button/button.component';
import { IconComponent } from '../../icon/icon.component';
import { type BreadcrumbSizeOption, breadcrumbSizes } from '../breadcrumb.component';

@Component({
  selector: 'evc-breadcrumb-item',
  imports: [IconComponent, ButtonComponent, RouterLink],
  templateUrl: './breadcrumb-item.component.html',
  styleUrls: ['./breadcrumb-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[attr.data-size]': 'size()',
  },
})
export class BreadcrumbItemComponent {
  readonly itemSelected = output();
  readonly disable = input<boolean>(false);
  /** if true - render as the current location: non-interactive, disabled-colored, no trailing separator */
  readonly current = input<boolean>(false);
  readonly homeIcon = input<boolean>(false);
  /** if provided - render as a routerLink anchor, else acts as a click button */
  readonly link = input<Maybe<string | string[]>>(undefined);
  readonly size = input<BreadcrumbSizeOption>(breadcrumbSizes.SMALL);

  onClick(): void {
    if (this.disable() || this.current()) return;
    this.itemSelected.emit();
  }
}
